// extracted by mini-css-extract-plugin
export default {"logTable":"activityLog_logTable__OqkKP","recordRow":"activityLog_recordRow__kllaV","searchRecords":"activityLog_searchRecords__+PLHr"};